/**
 * Only disabled items are badged. The lists hide them by default, so badging
 * the active ones too would put an identical chip on every visible row and say
 * nothing.
 */
export function DisabledBadge() {
  return (
    <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap">
      Disattivato
    </span>
  );
}
